import Class from './c-select-test';
import './c-select-test@';

export default Class;